export const convertToDays = milliSeconds => {
  const days = Math.floor(milliSeconds / (86400 * 1000));
  milliSeconds -= days * (86400 * 1000);
  const hours = Math.floor(milliSeconds / (60 * 60 * 1000));
  milliSeconds -= hours * (60 * 60 * 1000);
  const minutes = Math.floor(milliSeconds / (60 * 1000));
  milliSeconds -= minutes * (60 * 1000);
  const seconds = Math.floor(milliSeconds / 1000);
  return { days, hours, minutes, seconds };
};
export const getYYYYMMDD = date => {
  if (!(date instanceof Date)) return "";
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
};
export const convertToOldVuetify = date => {
  if (date instanceof Date) return getYYYYMMDD(date);
  const parsed = new Date(date);
  return isNaN(parsed.getTime()) ? "" : getYYYYMMDD(parsed);
};
